<template>
  <div style="width: 910px">
    <table
      class="TB_COLLAPSE operator-group-table"
      style="width: 100%"
    >
      <thead>
        <th colspan="6">{{ $route.meta.title }}</th>
      </thead>
      <tbody>
        <tr>
          <th>名称</th>
          <td>分组名称</td>
          <td colspan="6">
            <Input
              v-model="obj.name"
              style="width: 40%"
              class="left pl-4"
            />
          </td>
        </tr>
        <tr>
          <th
            rowspan="40"
            width="8%"
          >权限</th>
        </tr>
        <template v-for="(it, index) in pagedata">
          <tr :key="it.key">
            <td
              :rowspan="
                it.mix == 1
                  ? chunk(it.model.concat(pagedata[index + 1].model)).length
                  : chunk(it.model).length
              "
              v-if="noshow(it.key) && it.mix != -1"
              class="mt-2 mb-2"
              width="10%"
            >
              {{ it.name }}
            </td>
            <td
              v-if="noshow(it.key)"
              class="text-left pa-1"
            >
              <Checkbox
                v-for="(ckbox, index) in chunk(it.data)[0]"
                :key="index"
                :name="ckbox.name"
                v-model="it.model[index]"
                style="min-width: 110px; width: 25%"
                false-value="0"
                true-value="1"
              >
                <span>{{ ckbox.name }}</span>
              </Checkbox>
            </td>
          </tr>
          <tr
            v-if="chunk(it.model).length > 1"
            :key="index + 'i_2'"
          >
            <td class="text-left pa-1">
              <Checkbox
                v-for="(ckbox, index) in chunk(it.data)[1]"
                :key="index"
                :name="ckbox.name"
                v-model="it.model[4 + index]"
                style="min-width: 110px; width: 25%"
                false-value="0"
                true-value="1"
              >
                <span>{{ ckbox.name }}</span>
              </Checkbox>
            </td>
          </tr>
        </template>
        <tr>
          <td>备注</td>
          <td colspan="6">
            <Input
              type="textarea"
              v-model="obj.remark"
              :autosize="true"
              style="width: 90%"
              class="ml-3 left"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-right button-table-spacing">
      <Button
        type="primary"
        :to="{ name: 'operator-group' }"
      >返回</Button>
      <Button
        type="error"
        @click="ClickMethods(obj, pagedata)"
      >確定</Button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { Utile } from 'utils';

let checkboxtem = {
  template: `
	<td class="text-left pa-1">
		<Checkbox
			v-for="(ckbox, index) in chunk(it.data)[1]"
			:key="index"
			:name="ckbox.name"
			v-model="it.model[arrlen+index]"
			style="min-width:110px;width:25%"
			false-value=0
			true-value="1"
		>
			<span>{{ckbox.name}}</span>
		</Checkbox>
	</td>
	`,
  props: {
    arrlen: {
      type: Number,
      default: 0
    },
    arr: Array
  }
}

export default {
  props: {
    items: Array,
    ClickMethods: Function
  },
  components: {
    checkboxtem
  },
  data () {
    return {
      obj: {
        name: "",
        remark: "",
      },
      pagedata: [
        {
          name: "系统",
          mix: 0,
          key: "system",
          data: [{ name: "登录" }, { name: "操盘纪录" }, { name: "系统设定" }],
          model: [0, 0, 0]
        },
        {
          name: "营运站点管理",
          mix: 0,
          key: "member",
          data: [
            { name: "营运站点管理(浏览)" },
            { name: "营运站点管理(新增)" },
            { name: "营运站点管理(修改)" },
            { name: "营运站点管理(日志)" }
          ],
          model: [0, 0, 0, 0]
        },
        {
          name: "操作员",
          mix: 0,
          key: "operator",
          data: [
            { name: "操作员(浏览)" },
            { name: "操作员(新增)" },
            { name: "操作员(修改)" },
            { name: "操作员(日志)" }
          ],
          model: [0, 0, 0, 0]
        },
        {
          name: "操作员组",
          mix: 0,
          key: "opergroup",
          data: [
            { name: "操作员组(浏览)" },
            { name: "操作员组(新增)" },
            { name: "操作员组(修改)" },
            { name: "操作员组(删除)" }
          ],
          model: [0, 0, 0, 0]
        },
        {
          name: "期数管理",
          mix: 0,
          key: "period",
          data: [
            { name: "期数管理(浏览)" },
            { name: "期数管理(新增)" },
            { name: "期数管理(修改)" },
            { name: "期数管理(删除)" }
          ],
          model: [0, 0, 0, 0]
        },
        {
          name: "开奖管理",
          mix: 0,
          key: "lottery",
          data: [{ name: "开奖管理(浏览)" }, { name: "开奖管理(操作)" }],
          model: [0, 0]
        },
        {
          name: "现场监督",
          mix: 0,
          key: "inspect",
          data: [{ name: "现场监督(浏览)" }, { name: "现场监督(修改)" }],
          model: [0, 0]
        },
        {
          name: "即时注单",
          mix: 0,
          key: "immediate",
          data: [{ name: "即时注单" }],
          model: [0]
        },
        {
          name: "补货",
          mix: 0,
          key: "sup",
          data: [{ name: "补货注单" }, { name: "补货下注" }],
          model: [0, 0]
        },
        {
          name: "报表",
          mix: 0,
          key: "report",
          data: [{ name: "报表" }],
          model: [0]
        },
        {
          name: "注单数据",
          mix: 0,
          key: "indata",
          data: [{ name: "浏览" }, { name: "取消注单" }],
          model: [0, 0]
        },
        {
          name: "货币",
          mix: 0,
          key: "currency",
          data: [
            { name: "货币(浏览)" },
            { name: "货币(新增)" },
            { name: "货币(修改)" }
          ],
          model: [0, 0, 0]
        },
        {
          name: "游戏",
          mix: 1,
          key: "gameswitch",
          data: [
            { name: "彩种总表(浏览)" },
            { name: "彩种总表(修改)" },
            { name: "外站游戏(浏览)" },
            { name: "外站游戏(修改)" }
          ],
          model: [0, 0, 0, 0]
        },
        {
          name: "游戏",
          mix: -1,
          key: "gameset",
          data: [
            { name: "自开彩RTP调整(浏览)" },
            { name: "自开彩RTP调整(修改)" },
            { name: "自开彩开奖设定(浏览)" },
            { name: "自开彩开奖设定(修改)" },
            { name: "自开彩下注时间设定(浏览)" },
            { name: "自开彩下注时间设定(修改)" },
            { name: "日開彩結算時間(浏览)" },
            { name: "日開彩結算時間(修改)" },
          ],
          model: [0, 0, 0, 0, 0, 0, 0, 0]
        },
        // {
        //   name: "游戏",
        //   mix: -1,
        //   key: "settlement",
        //   data: [
        //     { name: "日開彩結算時間(浏览)" },
        //     { name: "日開彩結算時間(修改)" },
        //   ],
        //   model: [0, 0]
        // },
        {
          name: "彩种",
          key: "gameies",
          data: [
            { name: "彩种(浏览)" },
            { name: "彩种(新增)" },
            { name: "彩种(修改)" }
          ],
          model: [0, 0, 0]
        }
        // ------------------范例------------------
        // {
        //   name: "xxx",               ** 分组名称
        //   mix: 1,                    ** 是否合并下一组资料（0否、1是、-1被合并的组别
        //   key: "gameswitch",         ** api的key
        //   data: [                    ** 权限名称
        //     { name: "彩种总表(浏览)" },
        //     { name: "彩种总表(修改)" },
        //     { name: "电子游戏(浏览)" },
        //     { name: "电子游戏(修改)" }
        //   ],
        //   model: [0, 0, 0, 0]        ** 权限勾选值
        // }
        // ------------------范例------------------
      ]
    };
  },
  computed: {
    ...mapGetters(['getpermission']),
  },
  watch: {
    items (val) {
      const res = val[0]
      this.obj.name = res.name
      this.obj.remark = res.remark
      this.pagedata.map(it => {
        if (it.key == 'gameset') {
          Array.concat
          it.model = res[it.key].concat(res['settlement']).split('')
        } else {
          it.model = res[it.key].split('')
        }
      })
    }
  },
  methods: {
    noshow (val) {
      let noShowArr = ['currency', 'gameies']
      return noShowArr.indexOf(val) != -1 ? false : true
    },
    chunk (arr) {
      return Utile.chunk(arr, 4);
    }
  }
};
</script>
<style lang="scss">
.operator-group-table {
  .ivu-checkbox-wrapper {
    margin-right: 0;
    .ivu-checkbox + span {
      margin-right: 0;
    }
  }
}
</style>